import React, { MouseEvent } from 'react';
import { Tag } from '../../../models/Menu.model';
import FavoriteButton from '../../../containers/try2/Customization/FavoriteButton';
import TagSymbol from '../../Molecules/Symbols/Symbol';
import { isItCreateYourOwnItem } from '../../../helpers/helperMethods';
import { useLocation } from 'react-router';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { useIsDesignV2 } from '../../../hooks/useIsDesignV2';

interface IItemDetail {
  styleClasses: { readonly [key: string]: string };
  name: string;
  description: string;
  unAvailableModifiers: any;
  tags:Tag[];
  item:any;
  favoriteButtonHandler: (e: MouseEvent<HTMLButtonElement> ,item)=> void;
  favourite: any;
  authInfo: any;
}

const ItemDetail: React.FC<IItemDetail> = (props) => {
  const { styleClasses, name, description, unAvailableModifiers, tags, item, favoriteButtonHandler, favourite, authInfo } = props;
  const location = useLocation();
  const isThisMobile = useCheckMobileScreen();
  const isDesignV2 = useIsDesignV2()

  const showFavrtButton = () => {
    if(authInfo?.userId && !isItCreateYourOwnItem(item?.is_create_your_own)){
      return true
    }
    return false
  }
  return (
    <React.Fragment>
      <div className={`d-flex flex-fill single-item-title-wrap align-items-start ${!showFavrtButton() && 'cz-mt-32'}`}>
        <h6 className={`text-md-uppercase text-start f-sm-s18 me-2 me-md-0 ls-sm-normal ${isDesignV2 ? 'fot-Visby-cf' : 'font-sm-Cls' }`} data-testid='item-details-name'>
          {name}
        </h6>
        {!isDesignV2 && <TagSymbol tags={tags} />}
        {showFavrtButton() && (
          <FavoriteButton
            favIcon={true}
            buttonHandler={favoriteButtonHandler}
            className="d-lg-none position-static flex-fill text-end ms-2"
            item={item}
            favourite={favourite} isIconblueFill={false}          />
        )}
      </div>
      <p className={`${styleClasses.item_subtitle_wrap} text-start p-18 mb-1 ${isDesignV2 && "f-sm-s14"}`}>
        {description}
      </p>
      {unAvailableModifiers && (
      <p
        className={`${styleClasses.item_subtitle_wrap} text-md-start text-sm-center f-s18 f-sm-s16 mb-md-4 mb-3 pt-3 pt-md-1 clr-dark-red `}
      >
            {`Unfortunately, we are currently out of ${unAvailableModifiers} today.`}
      </p>
        )}
    </React.Fragment>
  );
};

export default ItemDetail;
